import { LegalClientBodyType } from 'api/types/entity';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  selectSchema,
} from 'libs/form';
import { SelectType } from 'types/selectType';

export interface BodyFormType {
  type: SelectType<LegalClientBodyType>;
  name: string;
  otherType?: string;
  reason: string;
}

const isOtherType = (value: SelectType<LegalClientBodyType>) =>
  value?.value === LegalClientBodyType.Other;

export const getSchema = (): ObjectSchema<BodyFormType> =>
  object({
    type: selectSchema(Object.values(LegalClientBodyType))
      .default(null)
      .required(),
    name: string().max(200).required(),
    otherType: string().when('type', {
      is: isOtherType,
      then: (schema) => schema.required().max(200),
    }),
    reason: string().required(),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<BodyFormType>();

export type FormErrors = FormErrorsBase<BodyFormType>;
